import { PolicyType } from '@aaa-ncnu-ie/mypolicy-api-customers';
import { Discount } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Stack, Card, Typography, Box } from '@mui/material';
import { useMemo } from 'react';

import Auto from '../../../assets/icons/Auto';
import CircleDivider from '../../../assets/icons/CircleDivider';
import Craftsman from '../../../assets/icons/Craftsman';
import colors from '../../../constants/colors';

interface DiscountsCardProps {
  discounts: Discount[];
  policyType: PolicyType;
}

const getPolicyIcon = (policyType: string): React.ComponentType => {
  switch (policyType) {
    case PolicyType.AUTO:
      return Auto;
    // case PolicyType.PUP:
    //   return Umbrella;
    case PolicyType.Property:
      return Craftsman;
    default:
      return Auto;
  }
};

const DiscountsCard = ({ discounts, policyType }: DiscountsCardProps) => {
  const PolicyIcon = getPolicyIcon(policyType);

  const discountArray = useMemo(() => {
    const discountList = [...discounts];
    const chunkSize = 2;
    return new Array(Math.ceil(discountList.length / chunkSize))
      .fill(null)
      .map(() => discountList.splice(0, chunkSize));
  }, [discounts]);

  return (
    <Card
      data-testid="DiscountsCard"
      component={Stack}
      spacing={3}
      direction={{ mobile: 'column', tablet: 'row-reverse', desktop: 'column' }}
      justifyContent="space-between"
      sx={{
        boxShadow: '0px 4px 8px rgba(25, 30, 43, 0.08)',
        px: { mobile: 2, tablet: 5, desktop: 2 },
        py: { mobile: 2, tablet: 3, desktop: 2 },
        borderRadius: 2,
        height: 'auto',
      }}
    >
      <Box
        sx={{
          backgroundColor: colors.csaaGray,
          borderRadius: 1,
          textAlign: 'center',
          py: 3,
          px: 6,
        }}
      >
        <PolicyIcon />
      </Box>
      <Stack spacing={3} direction="column">
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            fontSize: { mobile: 23, tablet: 28 },
            lineHeight: '40px',
            color: colors.csaaBlack,
          }}
        >
          Discounts
        </Typography>
        <Stack direction="column">
          {discountArray.map((discounts, i) => (
            <Stack
              key={i}
              direction="row"
              divider={<CircleDivider sx={{ mx: 1, my: 1 }} />}
              alignItems="center"
              flexWrap="wrap"
            >
              {discounts.map((discount) => (
                <Typography
                  key={discount.description}
                  sx={{
                    fontWeight: 400,
                    fontSize: 14,
                    fontFamily: 'Cabin',
                    fontKerning: 'normal',
                    color: colors.csaaBlack,
                  }}
                >
                  {discount.description}
                </Typography>
              ))}
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
};

export default DiscountsCard;
